import { __rest } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { store } from '../../../../store/index.js';
import { ComponentManager } from '../../../../components/ComponentManager.js';
import { AppMetaContext } from '../../../../components/appMetaContext.js';

const ContentArea = (_a) => {
    var { pages } = _a, otherProps = __rest(_a, ["pages"]);
    const appMeta = useContext(AppMetaContext);
    const getPageDefs = (pages) => {
        const pageArr = [];
        const allPages = store.getState().pages;
        pages.forEach((page) => {
            pageArr.push(allPages.find((pg) => pg.pageId === page));
        });
        return pageArr;
    };
    const pageDefs = getPageDefs(pages);
    return React.createElement("div", Object.assign({}, otherProps),
        React.createElement(Routes, null, pageDefs && pageDefs.map((page) => {
            var _a;
            let route;
            if (Array.isArray(page.path)) {
                route = page.path.map((pathName) => { var _a; return React.createElement(Route, { path: pathName, key: pathName, element: ComponentManager({ pageId: page.id, pageName: page.name, appName: (_a = appMeta === null || appMeta === void 0 ? void 0 : appMeta.appName) !== null && _a !== void 0 ? _a : "", components: page.components, events: page.events, rootComponentId: page.rootComponentId }) }); });
            }
            else {
                route = React.createElement(Route, { path: page.path, key: page.path, element: ComponentManager({ pageId: page.id, appName: (_a = appMeta === null || appMeta === void 0 ? void 0 : appMeta.appName) !== null && _a !== void 0 ? _a : "", pageName: page.name, components: page.components, events: page.events, rootComponentId: page.rootComponentId }) });
            }
            return route;
        })));
};

export { ContentArea as default };
//# sourceMappingURL=ContentArea.js.map
